import { DEFAULT_THEME, isTheme, type Theme } from './uiSlice';

/** Also read by the inline script in index.html, which applies the theme before React starts. */
export const THEME_STORAGE_KEY = 'pasta.theme.v1';

export function loadTheme(storage: Storage | undefined): Theme {
  try {
    const stored = storage?.getItem(THEME_STORAGE_KEY);
    return isTheme(stored) ? stored : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function saveTheme(storage: Storage | undefined, theme: Theme): void {
  try {
    storage?.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // storage blocked: the choice lasts for this session only
  }
}
